import React from "react";
import bannerdesktop from "./dekstop.png";
import bannermobile from "./mobile.png";
import "./banner.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

const banner = () => {
  const wapromo = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281319499502&text=Halo%20Reza,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(prelaunching)%20https://marketingbsdcity.com/&type=phone_number&app_absent=00";
    window.location.href = whatsappLink;
  };
  const pagelink = () => {
    const linkPage = "https://marketingbsdcity.com/izzi";
    window.location.href = linkPage;
  };
  return (
    <div className="banner">
      <div className="title">
        <div className="header">New Launching BSD City IZZI</div>
      </div>
      <div className="container-banner">
        <img src={bannerdesktop} alt="hankyu" className="desktop" />
        <img src={bannermobile} alt="hankyu" className="mobile" />
        <div className="button-wa-promo">
          <button onClick={wapromo} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Get More Promo
          </button>
          <button onClick={pagelink} className="whatsapp">
            Detail Product <FontAwesomeIcon icon={faAngleRight} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default banner;
